import React from "react";
import Card from "../../components/Card";
import updateNotes from "./updateNotes.json";
import { parseDate } from "../../helpers/functions";

export default function UpdateNotes() {
  const notesList = updateNotes?.items || [];
  return (
    <div className="container">
      <div className="flex items-center justify-between mb-10">
        <h1 className="page-title mb-0">Update Notes</h1>
      </div>
      {notesList.length > 0 ? (
        <div className="flex flex-col gap-4">
          {notesList.reverse().map((note, index) => {
            return (
              <Card key={index}>
                <div className="flex flex-col mb-2">
                  <h2 className="text-lg font-medium">{note.title}</h2>
                  <p>{parseDate(note.createdOn, false)}</p>
                </div>
                <p>{note.message}</p>
              </Card>
            );
          })}
        </div>
      ) : (
        <Card>No update notes</Card>
      )}
    </div>
  );
}
